import { Button, Col, Row, Input, DatePicker } from "antd";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import SelectStatus from "../../../components/SelectStatus";
import SelectStatusPayment from "../../../components/SelectStatusPayment";
import UserManualButton from "../../../components/UserManualButton";
import dayjs from "dayjs";
import SelectClient from "../../../components/SelectClient";
const { Search } = Input;

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const onSearch = (value) => {
    updateSearchParams({ search: value || null, page: 1 });
  };
  const onClear = () => {
    updateSearchParams({ search: null, page: 1 });
  };

  const updateSearchParams = (params = {}) => {
    const newSearchParams = new URLSearchParams(searchParams);

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        newSearchParams.set(key, value);
      } else {
        newSearchParams.delete(key);
      }
    });

    setSearchParams(newSearchParams);
  };

  return (
    <Row
      align="top"
      style={{ marginBottom: "18px" }}
      justify={"space-between"}
      gutter={[8, 8]}
    >
      <Col lg={16} xs={24}>
        <Row gutter={[8, 8]} align={"middle"}>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Status</p>
              <SelectStatusPayment
                value={searchParams.get("status") || null}
                onChange={(e) =>
                  updateSearchParams({ status: e || null, page: 1 })
                }
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p
                style={{
                  marginBottom: 4,
                  padding: 2,
                  fontSize: 12,
                  marginBottom: 6,
                }}
              >
                Tanggal Terbit Invoice
              </p>
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                placeholder="Pilih Tanggal"
                value={
                  searchParams.get("invoice_date")
                    ? dayjs(searchParams.get("invoice_date"))
                    : null
                }
                onChange={(e) =>
                  updateSearchParams({
                    invoice_date: e ? dayjs(e).format("YYYY-MM-DD") : null,
                    page: 1,
                  })
                }
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Tanggal Bayar</p>
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                placeholder="Pilih Tanggal"
                value={
                  searchParams.get("paid_at")
                    ? dayjs(searchParams.get("paid_at"))
                    : null
                }
                onChange={(e) =>
                  updateSearchParams({
                    paid_at: e ? dayjs(e).format("YYYY-MM-DD") : null,
                    page: 1,
                  })
                }
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Customer</p>
              <SelectClient
                value={+searchParams.get("client_id") || null}
                onChange={(e) =>
                  updateSearchParams({ client_id: e || null, page: 1 })
                }
              />
            </>
          </Col>
          <Col lg={3} md={4} sm={5} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                Clear Filter
              </p>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => {
                    setSearchParams({});
                  }}
                >
                  Clear Filter
                </Button>
                <UserManualButton />
              </div>
            </>
          </Col>
        </Row>
      </Col>
      <Col lg={8} xs={24}>
        <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
          <Col xl={12} lg={14} md={6} sm={8} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                Search
              </p>
              <Search
                placeholder="Input Name or Transaction Number"
                allowClear
                defaultValue={searchParams.get("search") || null}
                onSearch={onSearch}
                style={{ width: "100%" }}
                onClear={onClear}
              />
            </>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default FilterMenu;
